import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  href?: string;
  className?: string;
  /** Value reported to the Meta Pixel as content_name on InitiateCheckout. */
  trackingLabel?: string;
};
export function CtaButton({
  children,
  variant = 'primary',
  href = '#pricing',
  className = '',
  trackingLabel = 'Megakit Calistenia Cero Límites'
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-center text-sm font-extrabold tracking-tight transition-[background-color,color,transform,border-color] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:text-base';
  const styles = variant === 'primary' ? 'bg-gold text-ink hover:bg-gold-light active:scale-[0.99] shadow-gold' : 'border-2 border-gold/50 text-gold hover:bg-gold hover:text-ink active:scale-[0.99]';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: trackingLabel,
      currency: 'ARS'
    });
  };
  const isExternal = href.startsWith('http');
  return <a href={href} onClick={handleClick} rel={isExternal ? 'noopener noreferrer' : undefined} className={`${base} ${styles} ${className}`} data-id="element-63" data-mp="3ew9hooedlfjm">
      <span data-id="element-64" data-mp="3owtkhvhjms3y">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-65" data-mp="3ovigbuk6ricb" />
    </a>;
}